import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { getMe } from '../../store/reducers/profile/asyncActions';
import { withdrawFunds } from '../../store/reducers/withdrawals/asyncActions';
import WithdrawModal, { TWithdrawFormState } from './components/WithdrawModal';
import WithdrawProcessModal from './components/WithdrawProcessModal';
import WithdrawCompletedModal from './components/WithdrawCompletedModal';
import WithdrawErrorModal from './components/WithdrawErrorModal';

type TWithdawalsModalProps = {
  open: boolean;
  onClose: () => void;
}

type TModalType = 'withdraw' | 'processing' | 'withdraw-complete' | 'withdraw-error'

function WithdawalsModal({ onClose: closeHandler, open }: TWithdawalsModalProps) {
  const { settings: settingsData } = useAppSelector(({ settings }) => settings);
  // const { enqueueSnackbar } = useSnackbar();

  const dispatch = useAppDispatch();

  const [modal, setModal] = useState<TModalType | undefined>();

  useEffect(() => {
    if (open) {
      setModal('withdraw');
    }
  }, [open]);

  const onClose = () => {
    setModal(undefined);

    closeHandler();
  };
  const manualApproveWithdraw = settingsData?.manual_approvment_amount ?? 0;

  const onWithdrawProcess = async (form: TWithdrawFormState) => {
    const amount = (parseFloat(form.state.usdt) * 10 ** 6).toString();

    if (!amount) {
      return;
    }

    const result = await dispatch(withdrawFunds({ amount }));

    if (result.error) {
      // enqueueSnackbar('Currently withdrawal is not available. Try again later.', {
      //   variant: 'error',
      //   autoHideDuration: 3_000,
      // });
      setModal('withdraw-error');
      return;
    }
    if ((form.state.usdt || 1) < manualApproveWithdraw) {
      setModal('withdraw-complete');
    } else {
      setModal('processing');
    }

    dispatch(getMe());
  };

  return (
    <>
      <WithdrawModal onClose={onClose} open={modal === 'withdraw'} onWithdraw={onWithdrawProcess} />
      <WithdrawProcessModal onClose={onClose} open={modal === 'processing'} />
      <WithdrawCompletedModal onClose={onClose} open={modal === 'withdraw-complete'} />
      <WithdrawErrorModal onClose={onClose} open={modal === 'withdraw-error'} />
    </>
  );
}

export default WithdawalsModal;
